import { ProductStoreSourceCode } from '~/modules/catalog/types'

export const PRODUCT_STORE_CODES: ProductStoreSourceCode[] =
  Object.entries(ProductStoreSourceCode).map(([_, value]) => value)
